import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Row>
        <Col className="text-center">
          <h1 className="display-1 text-danger">403</h1>
          <h2 className="mb-4">Access Denied</h2>
          <p className="lead mb-4">
            You don't have permission to access this resource.
          </p>
          <Button 
            className="btn btn-primary btn-color btn btn-primary" 
            onClick={() => navigate('/')}
          >
            Go to Dashboard
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Unauthorized;